"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n\n  ellipse, circle {\n    stroke: ", ";\n    transition: all ease 0.3s;\n    fill: ", ";\n  }\n\n  path {\n    fill: ", ";\n    transition: all ease 0.3s;\n  }\n\n  &:hover {\n    ellipse, circle {\n      fill: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n"], ["\n\n  ellipse, circle {\n    stroke: ", ";\n    transition: all ease 0.3s;\n    fill: ", ";\n  }\n\n  path {\n    fill: ", ";\n    transition: all ease 0.3s;\n  }\n\n  &:hover {\n    ellipse, circle {\n      fill: ", ";\n    }\n\n    path {\n      fill: ", ";\n    }\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Svg = _styledComponents2.default.svg.withConfig({
  displayName: "Svg",
  componentId: "neds3m-0"
})(_templateObject, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.fillColor];
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.fillColor];
});

Svg.defaultProps = {
  color: "neutral",
  fillColor: "white"
};

exports.default = Svg;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Svg.js
// module id = 59
// module chunks = 168707334958949